import React from 'react';
import { User } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function AboutSection() {
  return <section className="py-12 md:py-20 px-4 bg-spice-100" data-id="element-16">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl p-5 md:p-12 shadow-xl border border-spice-200" data-id="element-17">
        <h2 className="text-3xl font-bold text-gray-900 mb-4 md:mb-6 text-center" data-id="element-18">
          ¿Quién soy?
        </h2>

        <div className="flex justify-center mb-5 md:mb-8" data-id="element-19">
          <div className="w-24 h-24 md:w-36 md:h-36 rounded-full bg-spice-100 border-4 border-spice-300 shadow-lg flex items-center justify-center overflow-hidden" data-id="element-20">
            <User className="w-12 h-12 md:w-20 md:h-20 text-spice-400" data-id="element-21" />
          </div>
        </div>

        <div className="prose prose-lg text-gray-700 mx-auto space-y-4 md:space-y-6" data-id="element-22">
          <p data-id="element-23">
            Hola, soy Ana. Si estás leyendo esto, probablemente te pase lo mismo
            que a mí al principio: querías hacer plata desde casa, pero te
            trababas en 3 cosas:
          </p>

          <ul className="list-none space-y-2 font-medium text-spice-800 bg-spice-50 p-4 md:p-6 rounded-xl border border-spice-200" data-id="element-24">
            <li data-id="element-25">"¿Qué vendo que se compre siempre?"</li>
            <li data-id="element-26">"¿Cuánto cobro sin regalar mi trabajo?"</li>
            <li data-id="element-27">"¿Qué digo por WhatsApp sin pasar vergüenza?"</li>
          </ul>

          <p data-id="element-28">
            A fuerza de prueba y error armé un método simple: condimentos
            caseros (fáciles de producir, baratos de empezar y con demanda
            real).
          </p>

          <p data-id="element-29">
            Y de ahí salió esta "Biblia": un sistema con recetas, costos,
            precios, etiquetas y scripts de venta para que no dependas de
            inspiración… solo de ejecutar.
          </p>

          <p className="font-bold text-xl text-gray-900 text-center py-4" data-id="element-30">
            No te prometo magia. Te doy un plan para que arranques con pasos
            claros.
          </p>
        </div>

        <div className="mt-6 md:mt-10 text-center" data-id="element-31">
          <CtaButton text="AGREGAR AL CARRITO" className="mb-4" data-id="element-32" />
          <p className="text-sm text-gray-500" data-id="element-33">
            Acceso inmediato a La Biblia de los Condimentos + Todos los Bonos »
          </p>
        </div>
      </div>
    </section>;
}